
import Technology from "@/packages/technology/technology.js";
import OperationPlatform from '@/project-views/operation-platform/index.js';
import Preview from "@/packages/topo-preview/topo-preview.js";
import DeviceController from "@/project-views/device-controller/device-controller.js";
import statistics from '@/project-views/statistics/statistics.js';
import technologyAdmin from '@/packages/technoloyAdmin/index';

// 部分子应用再需要的时候再安装，启动时安装会导致下载文件过多，首页加载变慢
// 异步加载不适合在新窗口打开
export default (Application) => {
    Application.install([
        //@parma name 加载的包中所包含的子应用
        //@param package 需要异步加载的包
        {
            names: ['desktop', 'apps'],
            package: () => import('@/packages/desktop/desktop.js'),//主界面加载
        },
       
        import('@/packages/codeEditor/index.js'),
        import('@/project-views/technology-2d-edit/2d-edit.js'),
        import("@/project-views/default/default.js"),

        Technology, //加载工艺组态编辑器
        technologyAdmin, //管理界面
        OperationPlatform,//加载运维平台
        import("@/project-views/xibengtan/index.js"), //加载西崩潭项目
        import("@/project-views/zs/index.js"), //加载西崩潭项目
        statistics, //加载统计
       
        import("@/project-views/select-project/index"), //加载选择项目
        Preview,//加载工艺组态预览
        DeviceController, //加载设备控制
        // 按需加载项目
        {
            names: ['xbt-setting-view'],
            package: () => import('@/project-views/setting/setting.js')
        },
        // 续盈炉
        {
            names: ['xyl-index'],
            package: () => import('@/project-views/xuyinglu/index.js')
        },

        // 安装网络地址，需要使用view-container容器显示
        /**
         * 示例
         * <view-container
          v-pre
          data-app="device"
          id="cocosEngine-content"></view-container>

          data-app对应安装的id
         */
          {
            id: 'sdt',
            url: 'http://116.62.78.108:19002/#/',
            name: '数电通'
          },
        {
            id: 'baidu',
            url: 'http://localhost:8082/',
            name: 'baidu'
        },
        {
            id: 'device',

            name: 'device',
            url: '/technologyCocos/web-mobile/index.html',
        }
    ])
}

